angular.module("ainapp")
    .controller("PrintDesignController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$http",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $http) {

            $scope.PageName = "Print Design";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.Init = function () {

                $scope.ViewVal = 0;
                $scope.voucherFile = {};

                $scope.SFiles = [];
                MainService.GetAllVoucherReportFiles().then(function (response) {
                    $scope.SFiles = response.data;
                });

                $scope.SRFiles = [];
                MainService.GetAllReportFiles().then(function (response) {
                    $scope.SRFiles = response.data;
                });
            }
            $scope.Init();




            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i])
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            }
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.voucherFile.FilePath = objXhr.responseText;
                            if ($scope.voucherFile.FilePath.includes("error")) {
                                $scope.voucherFile.FilePath = "";
                                toastr.error("Upload Error");
                            } else {
                                $scope.voucherFile.FilePath = objXhr.responseText;
                                toastr.success("File Uploaded");
                            }
                        } else {

                        }
                    }
                }
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info("File Uploading Please Wait");
                    if ($scope.ViewVal == 0) {
                        objXhr.open("POST", config.basePath + "UploadVoucherPrintFile");
                    } else {
                        objXhr.open("POST", config.basePath + "UploadVoucherPrintFileReport");
                    }
                    objXhr.send(data);
                } else {
                    toastr.error("Upload Error");
                }
            }
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }






                }])
